/*
* Storage types used for localStorage keys - Copied from Smartspace project
*/
export enum StorageType {
  LANGUAGE = '@DigivoxAgent:language',
  TOKEN = '@DigivoxAgent:token',
  REFRESH_TOKEN = '@DigivoxAgent:refresh-token',
  EXCHANGE_CODE_TOKEN = '@DigivoxAgent:exchange-code-token',

  UNITY_TOKEN = '@DigivoxAgent:unit-token',
  INPUT_DEVICE = '@DigivoxAgent:inputDevice',
  OUTPUT_DEVICE = '@DigivoxAgent:outputDevice',
  CHAT_SOCKET_TOKEN = '@DigivoxAgent:socket-token',
  START_ONLINE_TIME = '@DigivoxAgent:start-online-time',
  START_BREAK_TIME = '@DigivoxAgent:start-break-time',
  ATTENDANCE_NOTE = '@DigivoxAgent:attendance-note',

  AUTHORIZATION_SQUAD = 'authorization_smartspace',
  SIP_AUTHENTICATED = 'sip_authenticated',
}
